<script lang="ts">
  import ActionButton from '../ActionButton.svelte';
  import ArchiveIcon from '~/icons/ArchiveIcon.svelte';
  import { archiveModal } from '~/calendar/Archive.svelte';
</script>

<ActionButton onClick={() => archiveModal.push()}>
  <ArchiveIcon />
  Archive
</ActionButton>
